export const fetchWrapper = (url, { body, ...customConfig } = {}) => {
  const headers = { 'Content-Type': 'application/json' };

  const config = {
    method: body ? 'POST' : 'GET',
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  return window.fetch(url, config).then(async response => {
    const data = await response.json();
    if (response.ok) {
      return data;
    } else {
      return Promise.reject(data);
    }
  });
};

export const calcPercent = (partialValue, totalValue) =>
  (100 * partialValue) / totalValue;

export const getLegalConsentHtml = (
  { price, periodPrice, disclaimer, currencySymbol = '$' },
  t,
) => {
  const formatPrice = value => `${currencySymbol}${value.toFixed(2)}`;
  const isQuarterly = disclaimer === 'quarterly';
  const renewalDateText = t(
    isQuarterly ? 'legal_next_renewal_date' : 'legal_next_monthly_renewal_date',
  );

  if (periodPrice !== price) {
    return t('legal_consent_intro', {
      trialPeriod: t('legal_1_week_introductory_offer'),
      introPrice: formatPrice(periodPrice),
      renewalPrice: formatPrice(price),
      duration: t('month'),
      renewalDateText,
    });
  }

  return t('legal_consent_renews', {
    planName: t(isQuarterly ? 'legal_plan_3_month' : 'legal_plan_1_month'),
    price: formatPrice(price),
    renewalPrice: formatPrice(price),
    cadence: t(isQuarterly ? 'legal_every_3_months' : 'monthly'),
    renewalDateText,
  });
};
